var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoverningStandardProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "#5A7CB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7188 16.0008H18.9938V16.88H13.7188V16.0008ZM13.7188 13.3633H18.9938V14.2425H13.7188V13.3633Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3571 22.1561L13.6423 20.7086C12.8683 20.2968 12.221 19.6821 11.7699 18.9303C11.3189 18.1786 11.0811 17.3182 11.082 16.4415V10.7268C11.0823 10.4937 11.175 10.2703 11.3398 10.1054C11.5046 9.94062 11.7281 9.84791 11.9612 9.84766H20.7529C20.986 9.84791 21.2095 9.94062 21.3743 10.1054C21.5392 10.2703 21.6319 10.4937 21.6321 10.7268V16.4415C21.6331 17.3181 21.3952 18.1785 20.9442 18.9303C20.4931 19.682 19.8459 20.2968 19.0719 20.7085L16.3571 22.1561ZM11.9612 10.7268V16.4415C11.9604 17.1588 12.155 17.8628 12.5241 18.4779C12.8932 19.093 13.4228 19.5959 14.0561 19.9328L16.3571 21.1597L18.6581 19.9328C19.2914 19.5959 19.821 19.093 20.19 18.4779C20.5591 17.8628 20.7537 17.1588 20.7529 16.4415V10.7268H11.9612Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoverningStandardProcess);
export default __webpack_public_path__ + "static/media/GoverningStandardProcess.1961c1ce231f45cf83040ff0cc025709.svg";
export { ForwardRef as ReactComponent };